import TableReportHelper from "report/helper";

export default async function reportSummary(indicador, visita, tipoName) {
    const h = new TableReportHelper(visita.data);
    const IndicadorClass = indicador.constructor;

    const params = visita.cliente.getParams(IndicadorClass, tipoName, indicador.type);

    if (!params) {
        return null;
    }
}
